import { download } from "../../persist/download";
import { lastAudio, setCopyLastAudio } from "../../speak/speakPhonemes";

const defaultFileName = 'founim.wav';

/** button that saves the last espeak audio clip played */
export function SaveLastAudio(props: { fileName?: string, disabled?: boolean }) {
  setCopyLastAudio(true);

  function save() {
    if (lastAudio === null) {
      return;
    }
    download(props.fileName ?? defaultFileName, lastAudio as ArrayBuffer, 'audio/wav');
  }

  return (<span>
    <button onClick={save} disabled={props.disabled}>save last audio</button>
  </span>)
}
